import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Pavlodar_obl.png'
import _imports_1 from '@/assets/images/pavl1.jpg'
import _imports_2 from '@/assets/images/pavl2.jpg'
import _imports_3 from '@/assets/images/pavl3.jpg'
import _imports_4 from '@/assets/images/pavl4.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Павлодарская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Павлодарская область – жемчужина «зеленого» туризма. Местные и иностранные путешественники с удовольствием отправляются в Баянаульский национальный парк, сюда же съезжаются любители горного отдыха зимой и пляжного – летом. Первые отправляются к горе Акбет, вторые – к одному из знаменитых озер региона. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Отдых На Природе")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Экотуры можно организовывать в любой уголок Павлодарской области, самыми известными туристическими дестинациями являются озера "),
          /*#__PURE__*/_createVNode("b", null, "Баянаульского национального парка"),
          /*#__PURE__*/_createTextVNode(" самое крупное из озерной системы "),
          /*#__PURE__*/_createVNode("b", null, "Сабындыколь"),
          /*#__PURE__*/_createTextVNode(" с особой мягкой, как будто мыльной водой, прозрачное озеро "),
          /*#__PURE__*/_createVNode("b", null, "Жасыбай"),
          /*#__PURE__*/_createTextVNode(", самое высокогорное – "),
          /*#__PURE__*/_createVNode("b", null, "Торайгыр"),
          /*#__PURE__*/_createTextVNode(". На Торайгыр и соседнее озеро – "),
          /*#__PURE__*/_createVNode("b", null, "Быржанколь"),
          /*#__PURE__*/_createTextVNode(" – организуются рыболовные туры. Трофеями могут стать сазан, карп, карась. В области много и других озер – более 1200, подавляющее большинство из них соленые. Поправить здоровье можно в санатории "),
          /*#__PURE__*/_createVNode("b", null, "«Мойылды»"),
          /*#__PURE__*/_createTextVNode(" на берегах лечебного грязевого озера с одноименным названием. ")
        ]),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Популярны, как показывает статистика туризма Павлодарской области, экскурсии по лесному природному резервату "),
          /*#__PURE__*/_createVNode("b", null, "«Ертіс орманы»"),
          /*#__PURE__*/_createTextVNode(" и двум его филиалам. Путешественники любят посещать уникальные, сохранившиеся со времен ледникового периода сосновые боры. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "8195")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "26,5")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "117433")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "7564")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Исторический Туризм")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Иностранных гостей, как свидетельствует статистика туризма, больше привлекают исторические и познавательные экскурсии. В регионе можно посетить историко-мемориальный комплекс "),
          /*#__PURE__*/_createVNode("b", null, "«Аккелин» , мавзолей Машхура Жусупа Копеева"),
          /*#__PURE__*/_createTextVNode(" – выдающегося ученого и поэта. Популярны поездки к наскальным рисункам «Олентинские писаницы» и в "),
          /*#__PURE__*/_createVNode("b", null, "грот Драверта"),
          /*#__PURE__*/_createTextVNode(", также известному наскальной живописью. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Как развивается туризм в Павлодарской области? В регионе работает порядка 70 туристических организаций, здесь открыто 35 мест размещения в формате домов отдыха. Разработано и утверждено более 10 типовых туристских маршрутов общей протяженностью более 200 км и ботаническая тропа. В перспективе – усовершенствование придорожной инфраструктуры. Интересным направлением являются туры к палеонтологическому памятнику природы "),
          /*#__PURE__*/_createVNode("b", null, "«Гусиный перелет»"),
          /*#__PURE__*/_createTextVNode(", где было обнаружено крупнейшее в Евразии захоронение древних ископаемых животных периода неогена. Со временем местные власти планируют обустроить здесь крупный палеонтологический парк, чтобы привлечь гостей из других регионов страны и из-за рубежа, ведь статистика туризма Казахстана показывает, что такие оригинальные дестинации пользуются успехом у иностранцев. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}